import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

// Config pública do site (flags, ex: shop_enabled).
// Buscada uma vez no boot da app e refresh manual via `refresh()`.
const AppConfigContext = createContext({ shopEnabled: false, loading: true, refresh: () => {} });

export function AppConfigProvider({ children }) {
  const [shopEnabled, setShopEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/config/public");
      setShopEnabled(!!data.shop_enabled);
    } catch (_) {
      // silêncio: se falhar, default = loja desligada (mais seguro para App Store review)
      setShopEnabled(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <AppConfigContext.Provider value={{ shopEnabled, loading, refresh }}>
      {children}
    </AppConfigContext.Provider>
  );
}

export const useAppConfig = () => useContext(AppConfigContext);
